import React, { useState, useEffect, forwardRef, useRef } from "react";
import { Button, Dialog, DialogContent, DialogActions, DialogTitle, Paper, FormHelperText, InputAdornment, TextField, IconButton, Checkbox, FormControlLabel, RadioGroup, Radio, Select, MenuItem, FormLabel, FormGroup, FormControl, Tabs, Tab, Box, InputLabel, Alert, AlertTitle, List, ListItem, ListItemText, Grid } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { gettingAllPaycodes, gettingAllWorkRules, updateCreditHolidayRule } from 'utils/CreditHolidayRule'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack';
import Draggable from 'react-draggable';
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';
import { TransferList } from "./TransferList";
import { nameValidation, normalizeString } from 'utils/Validations'

const PaperComponent = (props) => {
    const nodeRef = useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

const TextMaskCustom = forwardRef((props, ref) => {
    return (
        <IMaskInput
            {...props}
            mask="00:#0"
            definitions={{
                '0': /[0-9]/,
                '#': /[0-5]/,
            }}
            placeholder={props.name === 'long_interval' ? '99:00' : '24:00'}
            inputRef={ref}
            onAccept={(value) => props.onChange({ target: { name: props.name, value } })}
            overwrite
        />
    );
});


const AdmisibilityTabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ width: '100%' }}>
                    <>{children}</>
                </Box>
            )}
        </div>
    );
}

AdmisibilityTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const CreditTabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ width: '100%', mt: 0 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

CreditTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const AverageTabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <>{children}</>
                </Box>
            )}
        </div>
    );
}

AverageTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


const EditCreditHolidayRule = ({ open, setOpen, reloading, selectedRow, rows }) => {
    const { t } = useTranslation()
    const { enqueueSnackbar } = useSnackbar();
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [type_credit, setTypeCredit] = useState('')
    const [must_work_shift_before_holiday, setMustWorkShiftBeforeHoliday] = useState(false)
    const [must_work_shift_after_holiday, setMustWorkShiftAfterHoliday] = useState(false)
    const [must_work_shift_before_or_after_holiday, setMustWorkShiftBeforeOrAfterHoliday] = useState(false)
    const [must_work_shift_in_holiday, setMustWorkShiftInHoliday] = useState(false)
    const [shift_equivalent_to, setShiftEquivalentTo] = useState("")
    const [if_planned_more_one_shift_in_day, setIfPlannedMoreOneShiftInDay] = useState('')
    const [hours_belong, setHoursBelong] = useState('')
    const [zone_holiday_defined_by, setZoneHolidayDefinedBy] = useState('')
    const [pay_credits_like, setPayCreditsLike] = useState('')
    const [work_rule, setWorkRule] = useState([])
    const [selected_work_rule, setSelectedWorkRule] = useState("")
    const [quantity_of_hours, setQuantityOfHours] = useState('')
    const [time_deducted_from_holiday_credit, setTimeDeductedFromHolidayCredit] = useState('')
    const [consider_on_extratime_limit, setConsiderOnExtratimeLimit] = useState('')
    const [consider_on_extratime_consecutive_days, setConsiderOnExtratimeConsecutiveDays] = useState('')
    const [selected_paycodes_extra_limit, setSelectedPaycodesExtraLimit] = useState("")
    const [selected_paycodes_extra_consecutive_days, setSelectedPaycodesExtraConsecutiveDays] = useState("")
    const [paycodes, setPaycodes] = useState([])
    const [loading, setLoading] = useState(true)
    const [value, setValue] = useState(0);
    const [searchTermAvailable, setSearchTermAvailable] = useState('');
    const [searchTermTransferred, setSearchTermTransferred] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectTransferItems, setSelectTransferItems] = useState([]);
    const [transferredItems, setTransferredItems] = useState([]);
    const [selectAllAvailable, setSelectAllAvailable] = useState(false);
    const [selectAllTransferred, setSelectAllTransferred] = useState(false);
    const [availableItems, setAvailableItems] = useState([])
    const [movePaycodes, setMovePaycodes] = useState(true);
    const [loadingTransfer, setLoadingTransfer] = useState(true)
    const [alerts, setAlerts] = useState(false)

    useEffect(() => {
        const requests = async () => {
            try {
                const [paycodesResult, workRulesResult] = await Promise.allSettled([
                    gettingAllPaycodes(setLoading),
                    gettingAllWorkRules(setLoading)
                ]);

                if (paycodesResult.status === "fulfilled") {
                    const paycodes = paycodesResult.value;
                    setPaycodes(paycodes);
                } else {
                    console.error('Error in paycodes request:', paycodesResult.reason);
                }

                if (workRulesResult.status === "fulfilled") {
                    const workRules = workRulesResult.value;
                    setWorkRule(workRules);
                } else {
                    console.error('Error in work rules request:', workRulesResult.reason);
                }

                if (selectedRow[0] && rows) {
                    setName(selectedRow[0]?.name);
                    setDescription(selectedRow[0]?.description);
                    setMustWorkShiftBeforeHoliday(selectedRow[0]?.must_work_shift_before_holiday);
                    setMustWorkShiftAfterHoliday(selectedRow[0]?.must_work_shift_after_holiday);
                    setMustWorkShiftBeforeOrAfterHoliday(selectedRow[0]?.must_work_shift_before_or_after_holiday);
                    setMustWorkShiftInHoliday(selectedRow[0]?.must_work_shift_in_holiday);
                    setShiftEquivalentTo(selectedRow[0]?.shift_equivalent_to);
                    setTypeCredit(selectedRow[0]?.credit_type);
                    setIfPlannedMoreOneShiftInDay(selectedRow[0]?.if_planned_more_one_shift_in_day);
                    setQuantityOfHours(selectedRow[0]?.amount_hours);
                    setTimeDeductedFromHolidayCredit(selectedRow[0]?.time_deducted_from_holiday_credit);
                    setHoursBelong(selectedRow[0]?.hours_belong);
                    setZoneHolidayDefinedBy(selectedRow[0]?.zone_holiday_defined_by);
                    setPayCreditsLike(selectedRow[0]?.pay_credits_like);
                    setSelectedWorkRule(selectedRow[0]?.work_rule_id);
                    setConsiderOnExtratimeLimit(selectedRow[0]?.consider_on_extratime_limit ? selectedRow[0]?.consider_on_extratime_limit : '');
                    setConsiderOnExtratimeConsecutiveDays(selectedRow[0]?.consider_on_extratime_consecutive_days ? selectedRow[0]?.consider_on_extratime_consecutive_days : '');
                    setPaycodes(prev => { return prev.filter(paycode => !selectedRow[0]?.paycodes.map(paycode => paycode.paycode_id).includes(paycode.paycode_id)) });
                    setTransferredItems(selectedRow[0]?.pay_credits_like === "Como si trabajara" ? [] : selectedRow[0]?.paycodes);
                    setSelectedPaycodesExtraLimit(selectedRow[0]?.paycode_extratime_limit_id ? selectedRow[0]?.paycode_extratime_limit_id : "");
                    setSelectedPaycodesExtraConsecutiveDays(selectedRow[0]?.paycode_extratime_consecutive_days_id ? selectedRow[0]?.paycode_extratime_consecutive_days_id : "");


                } else {
                    console.error('Error in selected row:', selectedRow);
                }

                setLoading(false);
            } catch (error) {
                console.error('Error during requests:', error.message);
                setLoading(false);
            }
        };

        if (open && selectedRow.length > 0) {
            requests();
        }


    }, [open, selectedRow, rows]);

    const existName = (name) => {
        const normalizedName = normalizeString(name);
        const selected = rows.find((row) => row.id === selectedRow[0]?.id);

        if (selected && normalizeString(selected.name) === normalizedName) {
            return false;
        }

        return rows.some((row) => normalizeString(row.name) === normalizedName);
    };

    const changes = () => {
        const hasChanges = name !== '' || description !== '' || type_credit !== '' || must_work_shift_before_holiday !== false || must_work_shift_after_holiday !== false || must_work_shift_before_or_after_holiday !== false || must_work_shift_in_holiday !== false || shift_equivalent_to !== '' || if_planned_more_one_shift_in_day !== '' || hours_belong !== '' || zone_holiday_defined_by !== '' || pay_credits_like !== '' || selected_work_rule !== '' || quantity_of_hours !== '' || time_deducted_from_holiday_credit !== '' || consider_on_extratime_limit !== '' || consider_on_extratime_consecutive_days !== '' || selected_paycodes_extra_limit !== '' || selected_paycodes_extra_consecutive_days !== '' || transferredItems.length > 0
        return hasChanges ? setAlerts(true) : closeForm()
    }

    const disabled = () => {
        return name === '' || type_credit === '';
    };


    const closeForm = () => {
        setName('')
        setDescription('')
        setMustWorkShiftBeforeHoliday(false)
        setMustWorkShiftAfterHoliday(false)
        setMustWorkShiftBeforeOrAfterHoliday(false)
        setMustWorkShiftInHoliday(false)
        setShiftEquivalentTo("")
        setIfPlannedMoreOneShiftInDay('')
        setHoursBelong('')
        setZoneHolidayDefinedBy('')
        setPayCreditsLike('')
        setSelectedWorkRule('')
        setQuantityOfHours('')
        setTimeDeductedFromHolidayCredit('')
        setConsiderOnExtratimeLimit('')
        setConsiderOnExtratimeConsecutiveDays('')
        setSelectedPaycodesExtraLimit('')
        setSelectedPaycodesExtraConsecutiveDays('')
        setValue(0)
        setTransferredItems([])
        setSelectedItems([])
        setSelectTransferItems([])
        setSelectAllAvailable(false)
        setSelectAllTransferred(false)
        setAvailableItems([])
        setMovePaycodes(true)
        setLoadingTransfer(true)
        setOpen(false)
        setLoading(true)
        setTypeCredit('')
        setAlerts(false)
    }

    const EditCreditHolidayRule = async () => {
        const data = {
            'name': name,
            'description': description,
            'must_work_shift_before_holiday': must_work_shift_before_holiday,
            'must_work_shift_after_holiday': must_work_shift_after_holiday,
            'must_work_shift_before_or_after_holiday': must_work_shift_before_or_after_holiday,
            'must_work_shift_in_holiday': must_work_shift_in_holiday,
            'amount_hours': quantity_of_hours ? quantity_of_hours : null,
            'shift_equivalent_to': shift_equivalent_to !== "" ? shift_equivalent_to : null,
            'credit_type': type_credit ? type_credit : null,
            'if_planned_more_one_shift_in_day': if_planned_more_one_shift_in_day !== "" ? if_planned_more_one_shift_in_day : null,
            'hours_belong': hours_belong !== "" ? hours_belong : null,
            'zone_holiday_defined_by': zone_holiday_defined_by !== "" ? zone_holiday_defined_by : null,
            'pay_credits_like': pay_credits_like !== "" ? type_credit === 'fixed_quantity_of_hours' ? null : pay_credits_like : null,
            'work_rule_id': selected_work_rule !== "" ? type_credit === 'fixed_quantity_of_hours' ? null : selected_work_rule : null,
            'consider_on_extratime_limit': consider_on_extratime_limit !== "" ? consider_on_extratime_limit : null,
            'consider_on_extratime_consecutive_days': consider_on_extratime_consecutive_days !== "" ? consider_on_extratime_consecutive_days : null,
            'paycode_extratime_limit_id': selected_paycodes_extra_limit !== "" ? selected_paycodes_extra_limit : null,
            'paycode_extratime_consecutive_days_id': selected_paycodes_extra_consecutive_days !== "" ? selected_paycodes_extra_consecutive_days : null,
            'paycode_list': transferredItems.length > 0 ? transferredItems : null,
            'time_deducted_from_holiday_credit': time_deducted_from_holiday_credit !== "" ? time_deducted_from_holiday_credit : null,
        }

        const response = await updateCreditHolidayRule(setLoading, data, selectedRow[0].id)
        if (response.status === 200) {
            enqueueSnackbar(t('settings.credit_holiday_rule.dialog.alerts.edit.success'), { variant: 'success' })
            setOpen(false)
            reloading()
            closeForm()
        } else {
            enqueueSnackbar(t('settings.credit_holiday_rule.dialog.alerts.edit.error'), { variant: 'error' })
            setLoading(false)
            console.error('Error:', response)
        }
    }

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    return;
                }
                changes()
            }}
            PaperComponent={PaperComponent}
            maxWidth="sm"
            fullWidth
            aria-labelledby="draggable-dialog-title"
            aria-describedby="draggable-alert-dialog-description"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{t('settings.credit_holiday_rule.dialog.titles.edit')}</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => changes()}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <Box sx={{ top: 0, zIndex: 10, pb: 1 }}>
                {
                    alerts &&
                    <Alert
                        variant='filled'
                        severity="warning"
                        sx={{ mt: 2 }}
                        action={
                            <>
                                <Button onClick={() => setAlerts(false)} color="inherit" size="small" variant='text' disableElevation>
                                    {t('general.alerts.unsaved_changes.buttons.yes')}
                                </Button>
                                <Button onClick={() => closeForm()} color='inherit' size='small' variant='text' disableElevation>
                                    {t('general.alerts.unsaved_changes.buttons.no')}
                                </Button>
                            </>
                        }
                    >
                        <AlertTitle>{t('general.alerts.unsaved_changes.message')}</AlertTitle>
                    </Alert>
                }
            </Box>
            <DialogContent dividers>
                {JSON.parse(localStorage.getItem("permissions")).filter(permission => ['timekeeper.CreditHolidayRulesById', 'timekeeper.WorkRule', 'timekeeper.GetPaycodes'].includes(permission)).length !== 3 &&
                    <Alert severity="warning">
                        <AlertTitle>{t('general.alerts.missing_permission.title')}</AlertTitle>

                        <List dense>
                            {JSON.parse(localStorage.getItem("permissions")).find(permission => permission === 'timekeeper.CreditHolidayRulesById') === undefined &&
                                <ListItem>
                                    <ListItemText
                                        primary={'timekeeper.CreditHolidayRulesById'}
                                    />
                                </ListItem>
                            }

                            {JSON.parse(localStorage.getItem("permissions")).find(permission => permission === 'timekeeper.WorkRule') === undefined &&
                                <ListItem>
                                    <ListItemText
                                        primary={'timekeeper.WorkRule'}
                                    />
                                </ListItem>
                            }

                            {JSON.parse(localStorage.getItem("permissions")).find(permission => permission === 'timekeeper.GetPaycodes') === undefined &&
                                <ListItem>
                                    <ListItemText
                                        primary={'timekeeper.GetPaycodes'}
                                    />
                                </ListItem>
                            }
                        </List>
                    </Alert>
                }

                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ mt: 1.5 }}>
                        <TextField
                            id='name'
                            fullWidth
                            autoComplete="off"
                            label={t('settings.credit_holiday_rule.dialog.inputs.name')}
                            value={name}
                            error={existName(name)}
                            onChange={(e) => {
                                if (nameValidation(e.target.value)) {
                                    setName(e.target.value)
                                    existName(e.target.value);
                                }
                            }}
                            required
                            slotProps={{
                                htmlInput: { maxLength: 100 },
                                input: {
                                    endAdornment: <InputAdornment position="end">{`${name.length}/100`}</InputAdornment>,
                                },
                            }}
                        />
                        <FormHelperText
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                mt: 0.5,
                                px: 1.75
                            }}
                        >
                            <span>{existName(name) ? t('settings.credit_holiday_rule.dialog.inputs.exist_name') : ''}</span>
                        </FormHelperText>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 1.5 }}>
                            <Tabs value={value} onChange={(event, newValue) => setValue(newValue)} aria-label="basic tabs example">
                                <Tab label={t('settings.credit_holiday_rule.dialog.inputs.admissibility')} {...a11yProps(0)} />
                                <Tab label={t('settings.credit_holiday_rule.dialog.inputs.credits')} {...a11yProps(1)} />
                                <Tab label={t('settings.credit_holiday_rule.dialog.inputs.average')} {...a11yProps(2)} disabled />
                            </Tabs>
                        </Box>
                    </Grid>
                    <AdmisibilityTabPanel value={value} index={0}>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <FormLabel component="legend">{t('settings.credit_holiday_rule.dialog.inputs.must_work_planned_shift')}</FormLabel>
                                <FormControl sx={{ mt: 1.5 }}>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={<Checkbox disabled={must_work_shift_before_or_after_holiday === true ? true : false} checked={must_work_shift_before_holiday} onChange={(e) => setMustWorkShiftBeforeHoliday(e.target.checked)} />}
                                            label={t('settings.credit_holiday_rule.dialog.inputs.must_work_shift_before_holiday')}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox disabled={must_work_shift_before_or_after_holiday === true ? true : false} checked={must_work_shift_after_holiday} onChange={(e) => setMustWorkShiftAfterHoliday(e.target.checked)} />}
                                            label={t('settings.credit_holiday_rule.dialog.inputs.must_work_shift_after_holiday')}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={must_work_shift_before_or_after_holiday} onChange={(e) => {
                                                setMustWorkShiftBeforeOrAfterHoliday(e.target.checked)
                                                if (e.target.checked) {
                                                    setMustWorkShiftBeforeHoliday(false)
                                                    setMustWorkShiftAfterHoliday(false)
                                                }
                                            }} />}
                                            label={t('settings.credit_holiday_rule.dialog.inputs.must_work_shift_before_or_after_holiday')}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={must_work_shift_in_holiday} onChange={(e) => setMustWorkShiftInHoliday(e.target.checked)} />}
                                            label={t('settings.credit_holiday_rule.dialog.inputs.must_work_shift_in_holiday')}
                                        />
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <FormLabel component="legend">{t('settings.credit_holiday_rule.dialog.inputs.shift_equivalent_to')}</FormLabel>
                                <RadioGroup row aria-label="shift_equivalent_to" name="shift_equivalent_to" value={shift_equivalent_to} onChange={(e) => setShiftEquivalentTo(e.target.value)}>
                                    <FormControlLabel value="Turno realmente planificado" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.shift_real_planned')} />
                                    <FormControlLabel value="Todo turno en el dia del turno planificad" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.all_shift_on_day_planned')} />
                                </RadioGroup>
                            </Grid>
                        </Grid>

                    </AdmisibilityTabPanel>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <CreditTabPanel value={value} index={1} sx={{ width: 100 }}>
                            <FormControl fullWidth>
                                <InputLabel id="credit_type-select-label">{t('settings.credit_holiday_rule.dialog.inputs.credit_type')}</InputLabel>
                                <Select
                                    labelId="credit_type-select-label"
                                    id="credit_type-select"
                                    value={type_credit}
                                    fullWidth
                                    autoWidth={true}
                                    label={t('settings.credit_holiday_rule.dialog.inputs.credit_type')}
                                    onChange={(e) => {
                                        setTypeCredit(e.target.value)
                                        switch (e.target.value) {
                                            case 'fixed_quantity_of_hours':
                                                setQuantityOfHours('')
                                                setTimeDeductedFromHolidayCredit('')
                                                setTransferredItems([])
                                                setConsiderOnExtratimeLimit('paycode')
                                                setConsiderOnExtratimeConsecutiveDays('paycode')
                                                setSelectedPaycodesExtraLimit('')
                                                setSelectedPaycodesExtraConsecutiveDays('')
                                                setPayCreditsLike('')
                                                break;
                                            case 'hours_from_schedule':
                                                setIfPlannedMoreOneShiftInDay('')
                                                setHoursBelong('')
                                                setZoneHolidayDefinedBy('')
                                                setPayCreditsLike('')
                                                setSelectedWorkRule('')
                                                setTransferredItems([])
                                                setConsiderOnExtratimeLimit('paycode')
                                                setConsiderOnExtratimeConsecutiveDays('paycode')
                                                setSelectedPaycodesExtraLimit('')
                                                setSelectedPaycodesExtraConsecutiveDays('')
                                                break;
                                            case 'percentage_of_salaries':
                                                break;
                                            case 'fixed_salaries':
                                                break;
                                            case 'average_shift_duration':
                                                break;
                                            case 'average_salaries':
                                                break;
                                            case 'average_shift_duration_with_free_time_rule':
                                                break;
                                            case 'average_salaries_with_free_time_rule':
                                                break;
                                            case 'percentage_of_salaries_utilizing_free_time_rule':
                                                break;
                                            default:
                                                break;
                                        }
                                    }}
                                >
                                    <MenuItem value={'fixed_quantity_of_hours'}>{t("settings.credit_holiday_rule.dialog.inputs.types_credits_selectable.fixed_quantity_of_hours")}</MenuItem>
                                    <MenuItem disabled value={'fixed_salaries'}>{t("settings.credit_holiday_rule.dialog.inputs.types_credits_selectable.fixed_salaries")}</MenuItem>
                                    <MenuItem value={'hours_from_schedule'}>{t("settings.credit_holiday_rule.dialog.inputs.types_credits_selectable.hours_from_schedule")}</MenuItem>
                                    <MenuItem disabled value={'percentage_of_salaries'}>{t("settings.credit_holiday_rule.dialog.inputs.types_credits_selectable.percentage_of_salaries")}</MenuItem>
                                    <MenuItem disabled value={'average_shift_duration'}>{t("settings.credit_holiday_rule.dialog.inputs.types_credits_selectable.average_shift_duration")}</MenuItem>
                                    <MenuItem disabled value={'average_salaries'}>{t("settings.credit_holiday_rule.dialog.inputs.types_credits_selectable.average_salaries")}</MenuItem>
                                    <MenuItem disabled value={'average_shift_duration_with_free_time_rule'}>{t("settings.credit_holiday_rule.dialog.inputs.types_credits_selectable.average_shift_duration_with_free_time_rule")}</MenuItem>
                                    <MenuItem disabled value={'average_salaries_with_free_time_rule'}>{t("settings.credit_holiday_rule.dialog.inputs.types_credits_selectable.average_salaries_with_free_time_rule")}</MenuItem>
                                    <MenuItem disabled value={'percentage_of_salaries_utilizing_free_time_rule'}>{t("settings.credit_holiday_rule.dialog.inputs.types_credits_selectable.percentage_of_salaries_utilizing_free_time_rule")}</MenuItem>
                                </Select>
                            </FormControl>
                            <Grid container spacing={2}>
                                {/* FORMULARIOS POR TIPO DE CREDITOS */}
                                {/* FORMULARIO TIPO HORAS DESDE HORARIO */}
                                {
                                    type_credit === 'hours_from_schedule' && (
                                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                            <Grid container spacing={2} sx={{ mt: 1.5 }}>
                                                <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                                                    <FormControl fullWidth>
                                                        <InputLabel>{t('settings.credit_holiday_rule.dialog.inputs.if_planned_more_one_shift_in_day')}</InputLabel>
                                                        <Select
                                                            label={t('settings.credit_holiday_rule.dialog.inputs.if_planned_more_one_shift_in_day')}
                                                            value={if_planned_more_one_shift_in_day ? if_planned_more_one_shift_in_day : ""}
                                                            fullWidth
                                                            autoWidth={true}
                                                            onChange={(e) => setIfPlannedMoreOneShiftInDay(e.target.value)}
                                                        >
                                                            <MenuItem value={'use_first_shift'}>{t("settings.credit_holiday_rule.dialog.inputs.use_first_shift")}</MenuItem>
                                                            <MenuItem value={'use_sum_of_all_shifts'}>{t("settings.credit_holiday_rule.dialog.inputs.use_sum_of_all_shifts")}</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                                                    <FormControl fullWidth>
                                                        <InputLabel>{t('settings.credit_holiday_rule.dialog.inputs.hours_belong')}</InputLabel>
                                                        <Select
                                                            label={t('settings.credit_holiday_rule.dialog.inputs.hours_belong')}
                                                            value={hours_belong}
                                                            fullWidth
                                                            onChange={(e) => setHoursBelong(e.target.value)}
                                                        >
                                                            <MenuItem value={'value_fixed_rule'}>{t("settings.credit_holiday_rule.dialog.inputs.fixe_rule_value")}</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                                    <FormControl fullWidth>
                                                        <InputLabel>{t('settings.credit_holiday_rule.dialog.inputs.zone_holiday_defined_by')}</InputLabel>
                                                        <Select
                                                            label={t('settings.credit_holiday_rule.dialog.inputs.zone_holiday_defined_by')}
                                                            value={zone_holiday_defined_by}
                                                            fullWidth
                                                            onChange={(e) => setZoneHolidayDefinedBy(e.target.value)}
                                                        >
                                                            <MenuItem value={'hours_on_holiday_table'}>{t("settings.credit_holiday_rule.dialog.inputs.hours_on_holiday_table")}</MenuItem>
                                                            <MenuItem value={'division_hours_into_days'}>{t("settings.credit_holiday_rule.dialog.inputs.division_hours_into_days")}</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                                                    <FormLabel component="legend">{t('settings.credit_holiday_rule.dialog.inputs.pay_credits_like')}</FormLabel>
                                                    <RadioGroup aria-label="pay_credits_like" name="pay_credits_like" value={pay_credits_like} onChange={(e) => {
                                                        setPayCreditsLike(e.target.value)
                                                        if (e.target.value === 'Como si trabajara') {
                                                            setConsiderOnExtratimeLimit('')
                                                            setSelectedPaycodesExtraLimit('')
                                                            setSelectedPaycodesExtraConsecutiveDays('')
                                                            setConsiderOnExtratimeConsecutiveDays('')
                                                            setTransferredItems([])
                                                        } else {
                                                            setConsiderOnExtratimeLimit('paycode')
                                                            setConsiderOnExtratimeConsecutiveDays('paycode')
                                                            setSelectedWorkRule('')
                                                        }

                                                    }}>
                                                        <FormControlLabel value="Como si trabajara" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.how_if_work')} />
                                                        <FormControlLabel value="En codigos de pagos" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.in_pay_codes')} />
                                                    </RadioGroup>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                                    <FormControl fullWidth>
                                                        <InputLabel>{t('settings.credit_holiday_rule.dialog.inputs.work_rule')}</InputLabel>
                                                        <Select
                                                            label={t('settings.credit_holiday_rule.dialog.inputs.work_rule')}
                                                            value={selected_work_rule ? selected_work_rule : ""}
                                                            fullWidth
                                                            disabled={pay_credits_like === 'En codigos de pagos' ? true : false}
                                                            renderValue={(selected) => {
                                                                const selectedWorkRule = work_rule.find(rule => rule.work_rule_id === selected);
                                                                return selectedWorkRule ? selectedWorkRule.name : '';
                                                            }}
                                                            onChange={(e) => setSelectedWorkRule(e.target.value)}
                                                        >
                                                            {
                                                                work_rule.map((work_rule) => (
                                                                    <MenuItem key={work_rule.work_rule_id} value={work_rule.work_rule_id}>{work_rule.name}</MenuItem>
                                                                ))
                                                            }

                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                {
                                                    pay_credits_like === 'En codigos de pagos' && (
                                                        <>
                                                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                                                <Grid sx={{ mt: 1.5 }}>
                                                                    <FormLabel component="legend">{t('settings.credit_holiday_rule.dialog.inputs.credits_included_in_payment_codes')}</FormLabel>

                                                                    <TransferList
                                                                        paycodes={paycodes}
                                                                        searchTermAvailable={searchTermAvailable}
                                                                        setSearchTermAvailable={setSearchTermAvailable}
                                                                        searchTermTransferred={searchTermTransferred}
                                                                        setSearchTermTransferred={setSearchTermTransferred}
                                                                        selectedItems={selectedItems}
                                                                        setSelectedItems={setSelectedItems}
                                                                        selectTransferItems={selectTransferItems}
                                                                        setSelectTransferItems={setSelectTransferItems}
                                                                        transferredItems={transferredItems}
                                                                        setTransferredItems={setTransferredItems}
                                                                        selectAllAvailable={selectAllAvailable}
                                                                        setSelectAllAvailable={setSelectAllAvailable}
                                                                        selectAllTransferred={selectAllTransferred}
                                                                        setSelectAllTransferred={setSelectAllTransferred}
                                                                        availableItems={availableItems}
                                                                        setAvailableItems={setAvailableItems}
                                                                        movePaycodes={movePaycodes}
                                                                        setMovePaycodes={setMovePaycodes}
                                                                        loadingTransfer={loadingTransfer}
                                                                        setLoadingTransfer={setLoadingTransfer}
                                                                        selected_paycodes_extra_consecutive_days={selected_paycodes_extra_consecutive_days}
                                                                        setSelectedPaycodesExtraConsecutiveDays={setSelectedPaycodesExtraConsecutiveDays}
                                                                        selected_paycodes_extra_limit={selected_paycodes_extra_limit}
                                                                        setSelectedPaycodesExtraLimit={setSelectedPaycodesExtraLimit}
                                                                    />
                                                                </Grid>
                                                                <Grid sx={{ mt: 3.5 }}>
                                                                    <FormLabel component="legend">{t('settings.credit_holiday_rule.dialog.inputs.consider_on_extratime_limit')}</FormLabel>
                                                                </Grid>
                                                                <Grid container direction='row' textAlign='end' columnSpacing={{ xs: 2, md: 2 }}>
                                                                    <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} sx={{ mt: 1.5 }}>
                                                                        <RadioGroup aria-label="consider_on_extratime_limit" name="consider_on_extratime_limit" value={consider_on_extratime_limit} onChange={(e) => {
                                                                            setConsiderOnExtratimeLimit(e.target.value)
                                                                            if (e.target.value !== 'paycode') {
                                                                                setSelectedPaycodesExtraLimit('')
                                                                            }

                                                                        }}>
                                                                            <FormControlLabel value="paycode" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.paycode')} />
                                                                            <FormControlLabel value="always" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.always')} />
                                                                            <FormControlLabel value="never" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.never')} />
                                                                        </RadioGroup>
                                                                    </Grid>
                                                                    <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} textAlign='initial' sx={{ mt: 1.5 }}>
                                                                        <FormControl fullWidth size="small">
                                                                            <InputLabel id='consider_on_extratime_limit'>{t('settings.credit_holiday_rule.dialog.inputs.paycode')}</InputLabel>
                                                                            <Select
                                                                                disabled={consider_on_extratime_limit === 'paycode' ? false : true}
                                                                                labelId='select_consider_on_extratime_limit'
                                                                                id="consider_on_extratime_limit"
                                                                                label={t('settings.credit_holiday_rule.dialog.inputs.paycode')}
                                                                                value={selected_paycodes_extra_limit ? selected_paycodes_extra_limit : ""}
                                                                                fullWidth
                                                                                renderValue={(selected) => {
                                                                                    const selectedPaycode = transferredItems.find(paycode => paycode.paycode_id === selected);
                                                                                    return selectedPaycode ? selectedPaycode.name : '';
                                                                                }}
                                                                                autoWidth={true}
                                                                                onChange={(e) => setSelectedPaycodesExtraLimit(e.target.value)}
                                                                            >
                                                                                {
                                                                                    transferredItems.map((paycode) => (
                                                                                        <MenuItem key={`consider_on_extratime_limit_paycode${paycode.paycode_id}`} value={paycode.paycode_id}>{paycode.name}</MenuItem>
                                                                                    ))
                                                                                }
                                                                            </Select>
                                                                        </FormControl>

                                                                    </Grid>
                                                                </Grid>
                                                                <Grid sx={{ mt: 1.5 }}>
                                                                    <FormLabel component="legend">{t('settings.credit_holiday_rule.dialog.inputs.consider_on_extratime_consecutive_days')}</FormLabel>
                                                                </Grid>
                                                                <Grid container direction='row' textAlign='end' columnSpacing={{ xs: 2, md: 2 }}>
                                                                    <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} sx={{ mt: 1.5 }}>
                                                                        <RadioGroup aria-label="consider_on_extratime_consecutive_days" name="consider_on_extratime_consecutive_days" value={consider_on_extratime_consecutive_days} onChange={(e) => {
                                                                            setConsiderOnExtratimeConsecutiveDays(e.target.value)
                                                                            if (e.target.value !== 'paycode') {
                                                                                setSelectedPaycodesExtraConsecutiveDays('');
                                                                            }
                                                                        }}>
                                                                            <FormControlLabel value="paycode" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.paycode')} />
                                                                            <FormControlLabel value="always" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.always')} />
                                                                            <FormControlLabel value="never" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.never')} />
                                                                        </RadioGroup>
                                                                    </Grid>
                                                                    <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} textAlign='initial' sx={{ mt: 1.5 }}>
                                                                        <FormControl fullWidth size="small">
                                                                            <InputLabel id="label_consider_on_extratime_consecutive_days">{t('settings.credit_holiday_rule.dialog.inputs.paycode')}</InputLabel>
                                                                            <Select
                                                                                labelId="select_consider_on_extratime_consecutive_days"
                                                                                id="consider_on_extratime_consecutive_days"
                                                                                value={selected_paycodes_extra_consecutive_days ? selected_paycodes_extra_consecutive_days : ""}
                                                                                label={t('settings.credit_holiday_rule.dialog.inputs.paycode')}
                                                                                renderValue={(selected) => {
                                                                                    const selectedPaycode = transferredItems.find(paycode => paycode.paycode_id === selected);
                                                                                    return selectedPaycode ? selectedPaycode.name : '';
                                                                                }}
                                                                                fullWidth
                                                                                disabled={consider_on_extratime_consecutive_days === 'paycode' ? false : true}
                                                                                onChange={(e) => setSelectedPaycodesExtraConsecutiveDays(e.target.value)}
                                                                            >
                                                                                {
                                                                                    transferredItems.map((paycode) => (
                                                                                        <MenuItem key={`consider_on_extratime_consecutive_days_paycode${paycode.paycode_id}`} value={paycode.paycode_id}>{paycode.name}</MenuItem>
                                                                                    ))
                                                                                }

                                                                            </Select>
                                                                        </FormControl>

                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </>
                                                    )
                                                }
                                            </Grid>
                                        </Grid>
                                    )
                                }
                                {/* FIN FORMULARIO HORAS DESDE HORARIO */}
                                {/* FORMULARIO TIPO CANTIDAD FIJA DE HORAS */}
                                {
                                    type_credit === 'fixed_quantity_of_hours' && (
                                        <Grid container spacing={1} sx={{ mt: 1.5 }}>
                                            <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                                                <TextField
                                                    fullWidth
                                                    autoComplete="off"
                                                    value={quantity_of_hours || ''}
                                                    label={t('settings.credit_holiday_rule.dialog.inputs.quantity_of_hours')}
                                                    onChange={(e) => setQuantityOfHours(e.target.value)}
                                                    slotProps={{
                                                        input: {
                                                            inputComponent: TextMaskCustom,
                                                            inputProps: { name: 'quantity_of_hours' }
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                                                <FormControl fullWidth>
                                                    <InputLabel>{t('settings.credit_holiday_rule.dialog.inputs.time_deducted_from_holiday_credit')}</InputLabel>
                                                    <Select
                                                        label={t('settings.credit_holiday_rule.dialog.inputs.time_deducted_from_holiday_credit')}
                                                        value={time_deducted_from_holiday_credit || ''}
                                                        fullWidth
                                                        autoWidth={true}
                                                        onChange={(e) => setTimeDeductedFromHolidayCredit(e.target.value)}
                                                    >
                                                        <MenuItem value={'value_zone_rule'}>{t('settings.credit_holiday_rule.dialog.inputs.value_zone_rule')}</MenuItem>
                                                        <MenuItem value={'none'}>{t('settings.credit_holiday_rule.dialog.inputs.none')}</MenuItem>
                                                        <MenuItem value={'hours_worked'}>{t('settings.credit_holiday_rule.dialog.inputs.hours_worked')}s</MenuItem>
                                                        <MenuItem value={'full_credit'}>{t('settings.credit_holiday_rule.dialog.inputs.full_credit')}</MenuItem>

                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ mt: 1.5 }}>
                                                <FormLabel component="legend">{t('settings.credit_holiday_rule.dialog.inputs.credits_included_in_payment_codes')}</FormLabel>
                                                <TransferList
                                                    paycodes={paycodes}
                                                    searchTermAvailable={searchTermAvailable}
                                                    setSearchTermAvailable={setSearchTermAvailable}
                                                    searchTermTransferred={searchTermTransferred}
                                                    setSearchTermTransferred={setSearchTermTransferred}
                                                    selectedItems={selectedItems}
                                                    setSelectedItems={setSelectedItems}
                                                    selectTransferItems={selectTransferItems}
                                                    setSelectTransferItems={setSelectTransferItems}
                                                    transferredItems={transferredItems}
                                                    setTransferredItems={setTransferredItems}
                                                    selectAllAvailable={selectAllAvailable}
                                                    setSelectAllAvailable={setSelectAllAvailable}
                                                    selectAllTransferred={selectAllTransferred}
                                                    setSelectAllTransferred={setSelectAllTransferred}
                                                    availableItems={availableItems}
                                                    setAvailableItems={setAvailableItems}
                                                    movePaycodes={movePaycodes}
                                                    setMovePaycodes={setMovePaycodes}
                                                    loadingTransfer={loadingTransfer}
                                                    setLoadingTransfer={setLoadingTransfer}
                                                    selected_paycodes_extra_consecutive_days={selected_paycodes_extra_consecutive_days}
                                                    setSelectedPaycodesExtraConsecutiveDays={setSelectedPaycodesExtraConsecutiveDays}
                                                    selected_paycodes_extra_limit={selected_paycodes_extra_limit}
                                                    setSelectedPaycodesExtraLimit={setSelectedPaycodesExtraLimit}
                                                />
                                            </Grid>
                                        </Grid>
                                    )
                                }

                            </Grid>
                            {/* FIN FORMULARIO HORAS DESDE HORARIO */}
                            {/* FORMULARIO TIPO CANTIDAD FIJA DE HORAS */}
                            {
                                type_credit === 'fixed_quantity_of_hours' && (
                                    <>
                                        <Grid sx={{ mt: 2.5 }}>
                                            <FormLabel component="legend">{t('settings.credit_holiday_rule.dialog.inputs.consider_on_extratime_limit')}</FormLabel>
                                        </Grid>
                                        <Grid container direction='row' textAlign='end' columnSpacing={{ xs: 2, md: 2 }}>
                                            <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} sx={{ mt: 1.5 }}>
                                                <RadioGroup aria-label="consider_on_extratime_limit" name="consider_on_extratime_limit" value={consider_on_extratime_limit} onChange={(e) => setConsiderOnExtratimeLimit(e.target.value)}>
                                                    <FormControlLabel value="paycode" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.paycode')} />
                                                    <FormControlLabel value="always" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.always')} />
                                                    <FormControlLabel value="never" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.never')} />
                                                </RadioGroup>
                                            </Grid>
                                            <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} textAlign='initial' sx={{ mt: 1.5 }}>
                                                <FormControl fullWidth size="small">
                                                    <InputLabel id='label_consider_on_extratime_limit'>{t('settings.credit_holiday_rule.dialog.inputs.paycode')}</InputLabel>
                                                    <Select
                                                        labelId='select_consider_on_extratime_limit'
                                                        id="consider_on_extratime_limit"
                                                        label={t('settings.credit_holiday_rule.dialog.inputs.paycode')}
                                                        value={selected_paycodes_extra_limit || ""}
                                                        fullWidth
                                                        disabled={loading}
                                                        renderValue={(selected) => {
                                                            const selectedPaycode = transferredItems.find(paycode => paycode.paycode_id === selected);
                                                            return selectedPaycode ? selectedPaycode.name : '';
                                                        }}
                                                        autoWidth={true}
                                                        onChange={(e) => setSelectedPaycodesExtraLimit(e.target.value)}
                                                    >
                                                        {
                                                            transferredItems.map((paycode) => (
                                                                <MenuItem key={`consider_on_extratime_limit_paycode${paycode.paycode_id}`} value={paycode.paycode_id}>{paycode.name}</MenuItem>
                                                            ))
                                                        }
                                                    </Select>
                                                </FormControl>

                                            </Grid>
                                        </Grid>
                                        <Grid sx={{ mt: 1.5 }}>
                                            <FormLabel component="legend">{t('settings.credit_holiday_rule.dialog.inputs.consider_on_extratime_consecutive_days')}</FormLabel>
                                        </Grid>
                                        <Grid container direction='row' textAlign='end' columnSpacing={{ xs: 2, md: 2 }}>
                                            <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} sx={{ mt: 1.5 }}>
                                                <RadioGroup aria-label="consider_on_extratime_consecutive_days" name="consider_on_extratime_consecutive_days" value={consider_on_extratime_consecutive_days} onChange={(e) => setConsiderOnExtratimeConsecutiveDays(e.target.value)}>
                                                    <FormControlLabel value="paycode" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.paycode')} />
                                                    <FormControlLabel value="always" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.always')} />
                                                    <FormControlLabel value="never" control={<Radio />} label={t('settings.credit_holiday_rule.dialog.inputs.never')} />
                                                </RadioGroup>
                                            </Grid>
                                            <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} textAlign='initial' sx={{ mt: 1.5 }}>
                                                <FormControl fullWidth size="small">
                                                    <InputLabel id="labeL_consider_on_extratime_consecutive_days">{t('settings.credit_holiday_rule.dialog.inputs.paycode')}</InputLabel>
                                                    <Select
                                                        labelId="consider_on_extratime_consecutive_days"
                                                        id="consider_on_extratime_consecutive_days"
                                                        value={selected_paycodes_extra_consecutive_days}
                                                        label={t('settings.credit_holiday_rule.dialog.inputs.paycode')}
                                                        renderValue={(selected) => {
                                                            const selectedPaycode = transferredItems.find(paycode => paycode.paycode_id === selected);
                                                            return selectedPaycode ? selectedPaycode.name : '';
                                                        }}
                                                        fullWidth
                                                        disabled={loading}
                                                        autoWidth={true}
                                                        onChange={(e) => setSelectedPaycodesExtraConsecutiveDays(e.target.value)}
                                                    >
                                                        {
                                                            transferredItems.map((paycode) => (
                                                                <MenuItem key={`consider_on_extratime_consecutive_days_paycode${paycode.paycode_id}`} value={paycode.paycode_id}>{paycode.name}</MenuItem>
                                                            ))
                                                        }

                                                    </Select>
                                                </FormControl>

                                            </Grid>
                                        </Grid>
                                    </>
                                )
                            }

                        </CreditTabPanel>
                    </Grid>
                    <AverageTabPanel value={value} index={2}>
                    </AverageTabPanel>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ mt: 1.5 }}>
                        <TextField
                            id="filled-textarea"
                            autoComplete="off"
                            fullWidth
                            placeholder={t('settings.credit_holiday_rule.dialog.inputs.max_description')}
                            label={t('settings.credit_holiday_rule.dialog.inputs.description')}
                            value={description}
                            rows={4}
                            multiline
                            slotProps={{
                                htmlInput: { maxLength: 255 },
                                input: {
                                    endAdornment: <InputAdornment position="end">{`${description.length}/255`}</InputAdornment>,
                                }
                            }}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </Grid>
                </Grid>

            </DialogContent>
            <DialogActions>
                <Button onClick={() => changes()} variant="contained" color="error">{t('general.buttons.cancel')}</Button>
                <Button disabled={disabled()} loading={loading} onClick={() => EditCreditHolidayRule()} variant="contained" color="primary">{t('general.buttons.save')}</Button>
            </DialogActions>
        </Dialog>
    )
}

export { EditCreditHolidayRule };